import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from "@angular/core";
import { AcmicService } from "../../../_services/acmic.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: "mapfre-loading",
  templateUrl: "./mapfre-loading.component.html",
  styleUrls: ["./mapfre-loading.component.scss"]
})
export class MapfreLoadingComponent implements OnInit {
  constructor(private acmicService: AcmicService) {}
  stateCode!: string;
  showContent = true;
  screenWidth = window.innerWidth;


  ngOnInit() {
    this.stateCode = this.acmicService.isACMIC() ? "ACMIC" : "MA";
  }
}
